// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__UKf6h","topWrap":"styles_topWrap__Ccwn8","title":"styles_title__c9s_H","counter":"styles_counter__t9pt9"};
module.exports.__checksum = "6c256b546b0d"
